export const CMS_EVENTS = {
    load: (action) => {
        window.addEventListener('shopify:section:load', () => {
            action();
        })
    },
    // TODO: add logic for other Shopify Theme Editor events e.g. shopify:section:unload, shopify:section:select, etc.
};


